import React, { useEffect, useState } from "react";
import { Box, Typography, useTheme, Modal } from "@mui/material";
// import { fetchQuote } from "../../apis/freeExternal.api";

interface LoadingWithAnimationProps {
  transparent?: boolean;
  open: boolean; // Controls whether the modal is open or closed
}

const LoadingWithAnimation: React.FC<LoadingWithAnimationProps> = ({
  transparent,
  open,
}) => {
  const theme = useTheme();
  const [rotation, setRotation] = useState({ x: 0, y: 0 });
  const [quote, setQuote] = useState("");

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const { clientX, clientY, currentTarget } = e;
    const { width, height, left, top } = currentTarget.getBoundingClientRect();

    const x = ((clientX - left) / width - 0.5) * 20; // Rotate based on X-axis
    const y = ((clientY - top) / height - 0.5) * -20; // Rotate based on Y-axis

    setRotation({ x, y });
  };

  const handleMouseLeave = () => {
    setRotation({ x: 0, y: 0 });
  };

  // const getQuote = async () => {
  //   await fetchQuote().then((res) => {
  //     if (!("error" in res)) {
  //       setQuote(res.quote);
  //     }
  //   });
  // };

  // useEffect(() => {
  //   getQuote();
  // }, []);

  return (
    <Modal open={open} sx={{ zIndex: 1300 }}>
      <Box
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          width: "100vw",
          backgroundColor: transparent
            ? "rgba(0, 0, 0, 0.5)" // Semi-transparent black background
            : theme.palette.background.default, // Default theme background
          color: theme.palette.primary.main,
          perspective: "1000px", // Add perspective for 3D effect
          overflow: "hidden",
        }}
      >
        {/* 3D Animated Circles */}
        <Box
          sx={{
            position: "relative",
            width: "150px",
            height: "150px",
            transformStyle: "preserve-3d",
            transform: `rotateX(${rotation.y}deg) rotateY(${rotation.x}deg)`,
            transition: "transform 0.1s ease-out",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              border: `4px solid ${theme.palette.primary.main}`,
              animation: "spin3D 2s linear infinite",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              width: "80%",
              height: "80%",
              top: "10%",
              left: "10%",
              borderRadius: "50%",
              border: `4px solid ${theme.palette.secondary.main}`,
              animation: "spinReverse3D 2s linear infinite",
            }}
          />
          <Box
            sx={{
              position: "absolute",
              width: "60%",
              height: "60%",
              top: "20%",
              left: "20%",
              borderRadius: "50%",
              border: `4px solid ${theme.palette.primary.light}`,
              animation: "pulse3D 1.5s ease-in-out infinite",
            }}
          />
        </Box>

        {/* Loading Text */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            textTransform: "uppercase",
            letterSpacing: "2px",
            animation: "fadeInOut 2s ease-in-out infinite",
            marginTop: "20px",
          }}
        >
          Loading, please wait...
        </Typography>

        {/* Subtext */}
        <Typography
          variant="body2"
          sx={{
            marginTop: "10px",
            color: theme.palette.text.secondary,
            animation: "fadeInOut 3s ease-in-out infinite",
          }}
        >
          {quote || "Preparing your experience..."}
        </Typography>

        {/* Custom CSS Animations */}
        <style>
          {`
            @keyframes spin3D {
              0% {
                transform: rotateX(0deg) rotateY(0deg);
              }
              100% {
                transform: rotateX(360deg) rotateY(360deg);
              }
            }

            @keyframes spinReverse3D {
              0% {
                transform: rotateX(360deg) rotateY(360deg);
              }
              100% {
                transform: rotateX(0deg) rotateY(0deg);
              }
            }

            @keyframes pulse3D {
              0%, 100% {
                transform: scale(1);
                opacity: 1;
              }
              50% {
                transform: scale(1.2);
                opacity: 0.5;
              }
            }

            @keyframes fadeInOut {
              0%, 100% {
                opacity: 1;
              }
              50% {
                opacity: 0.5;
              }
            }
          `}
        </style>
      </Box>
    </Modal>
  );
};

export default LoadingWithAnimation;
